import { useSelector } from "react-redux";
import { useGetTodosQuery } from "../features/api/apiSlice";
import Todo from "./Todo";

export default function TodoList() {
    const {data: todos, isLoading, isError} = useGetTodosQuery();

    let contentCompleted = null;
    let contentInCompleted = null;

    const filters = useSelector((state) => state.filters);
    const { status } = filters;

    const filterByStatus = (todo) => {
        const { status } = filters;
        switch (status) {
            case "Complete":
                return todo.completed;

            case "Incomplete":
                return !todo.completed;

            default:
                return true;
        }
    };

    const filterByColors = (todo) => {
        const { colors } = filters;
        if (colors.length > 0) {
            return colors.includes(todo?.color);
        }
        return true;
    };

    const filterByCompleted = todo => todo.completed;
    const filterByInCompleted = todo => !todo.completed;

    if(!isLoading && !isError && todos?.length > 0) {
        contentInCompleted = todos
                                .filter(filterByStatus)
                                .filter(filterByColors)
                                .filter(filterByInCompleted)
                                .map(todo => <Todo todo={todo} key={todo.id} />);
        contentCompleted = todos
                                .filter(filterByStatus)
                                .filter(filterByColors)
                                .filter(filterByCompleted)
                                .map(todo => <Todo todo={todo} key={todo.id} />);
    }

    return (
       <>
         <div className="mt-5 mb-5 text-gray-700 text-sm max-h-[300px]">
            {status !== "Complete" && <h1 className="mt-10">InCompleted</h1> }
            {contentInCompleted}
        </div>
        <div className="text-gray-700 text-sm max-h-[300px] overflow-y-auto">
            {status !== "Incomplete" && <h1 className="mt-10">Completed</h1> }
            {contentCompleted}
        </div>
       </>
    );
}
